import { fallbackLanguage, supportedLanguageCodes } from '../config';

// Return a valid language code with fallback protection.
export const languageFallback = (language, defaultLocale = fallbackLanguage) => {
  if (supportedLanguageCodes.includes(language)) {
    return language;
  }

  if (supportedLanguageCodes.includes(defaultLocale)) {
    return defaultLocale;
  }

  return fallbackLanguage;
};

export default languageFallback;